import React from "react";
// import Serviceitems from "../Components/Service/Serviceitems";
import Contact from "../Components/Contact/index";
import Counter from "../Components/Common/Counter";
import img1 from "../Images/Akb-images/1.png";
// import { Link } from "react-router-dom";
// import Slider from "../Components/Slider/Slider";
// import Testimonialcards from "../Components/Testi/Testimonial_cards";
import videoSource from "../Images/1.mp4"
import "./css/home.css"
import Gallery from "../Components/Gallery/Gallery";

const Home = () => {

  return (
    <div>
      {/* Video Section */}
      <section id="home" className="homevideo" style={{position:"relative"}}>
        <div className="dialouge">
          <h3 className="detail-name">Dr. Anjani Kumar Bhatnagar</h3>
          <h3 className="detail">Heading-Amity Technical Placement Centre</h3>
          <h3 className="detail">Amity Group</h3>
        </div>
        <video
          src={videoSource}
          autoPlay
          loop
          controls
          style={{
            width: "100%",
            height: "auto",
            objectFit: "cover",
          }}
        >
          Your browser does not support the video tag.
        </video>
      </section>
      {/* background: "#143d53" */}
      <section id="about-top" className="py100 center " style={{
        background: "#182047"
      }}>
        <div className="found_msg_head " style={{
          border: "2px solid white", height: 'auto', margin: "0 10px"
        }}>
          <div className="row">
            <div className="col-lg-8 col-md-12 d-flex" >
              <div className="about-img">
                <h3 style={{ fontWeight: "800", textAlign: 'left', paddingTop: "20px" }}>Vision</h3>
                <hr className="hrsytle" />
                <p>
                  Igniting the youthful minds with positivity and instilling a genuine spirit of success in their professional and personal lives.
                </p>
                <h3 style={{ fontWeight: "800", textAlign: 'left', paddingTop: "20px" }}>Mission</h3>
                <hr className="hrsytle" />
                <p>
                  I am committed to assisting students in the identification of their latent abilities, thereby enhancing their employability. This ensures the effective beginning of the student's career on campus, which will undoubtedly contribute to the nation's development.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 col-sm-12 col-12 mt-4 center d-flex justify-content-center align-items-center">
              <div className="about-top-img">
                <img alt="" style={{ borderRadius: '10px' }} src={img1} />
                {/* <div className="shadow_gold"/> */}
              </div>
            </div>
            {/* <div className="col-lg-3 col-md-12 col-sm-12 col-12 mt-2" >
              <div className="about-img">
                <h3 style={{ fontWeight: "600", textAlign: 'left', paddingTop: "10px" }}>Who are we ?</h3>
                <hr className="hrstyles" />
                <p style={{ textAlign: 'left' }}>
                  Gaur Legum, an acclaimed law firm in the world offers a full spectrum of legal services to clients spanning domestic and international domains on a variety of legal matters. Its inception traces back to 1988 when it was established in New Delhi, the Capital of India.
                  <br /><br />
                  Currently, the firm is based in Delhi-NCR and has associates in nearly all of India's significant...
                </p>
                <h3 className="greater_than" style={{ fontSize: "16px", margin: "0", textAlign: "end", color: "gold" }}><Link to="/about" style={{ color: "gold" }}>Read More </Link></h3>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      <Counter />
      <Gallery id="gallery"/>
      {/* <Serviceitems /> */}
      {/* <Testimonialcards /> */}
      <Contact />
    </div>
  );
};

export default Home;
